import React from 'react';

function DashboardCards(props) {
    return (
        <div className="w-full flex gap-3 p-3 flex flex-wrap">
            {
                props.quickReports&&props.quickReports.map(q=>
                    {return q.view && <q.view {...q}/>}
                )
            }
        </div>
    );
}

export default DashboardCards;